import React from 'react';
import PropTypes from 'prop-types';

import { Typeahead } from 'react-bootstrap-typeahead';

class BasicTypeahead extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            multiple: false,
            fieldActive: false,
            selected: [],
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selected !== this.state.selected) {
            this.setState({ selected: nextProps.selected });
        }
    }

    componentWillMount() {
        this.setState({selected: this.props.selected});
    }

    handleOnFocus = () => {
        this.setState({ fieldActive: !this.state.fieldActive});
    }

    handleOnBlur = () => {
        this.setState({ fieldActive: false});
    }

    handleOnChange = (e) => {
        this.setState({selected : e, fieldActive: false});
        this.props.onChange(e[0]);
    }

    render () {
        const { id, name, label, className, options } = this.props;
        const typeahead = this.state.selected[0] !== "" ?
            <Typeahead
                labelKey={name}
                multiple={this.state.multiple}
                options={options}
                onChange={this.handleOnChange}
                selected={this.state.selected}
                placeholder="Select Value"
                aria-label={`Select a ${label}`}
            />
            :  <Typeahead
                    labelKey={name}
                    multiple={this.state.multiple}
                    options={options}
                    onChange={this.handleOnChange}
                    placeholder="Select Value"
                    aria-label={`Select a ${label}`}
                />

        return (
            <div id={id} className={this.state.fieldActive ? `${className} active` : `${className}`} onFocus={this.handleOnFocus} onBlur={this.handleOnBlur}>
                <label htmlFor={name}> {label}</label>
                {typeahead}
            </div>
        );
    }
};

BasicTypeahead.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func,
}

export default BasicTypeahead;



// WEBPACK FOOTER //
// ./src/components/common/BasicTypeahead/BasicTypeahead.js